import { Component, Input, TemplateRef, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [NgTemplateOutlet],
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  protected ngbActiveModal = inject(NgbActiveModal);

  @Input({ required: true }) title!: string;
  @Input({ required: true }) buttonTextAction!: string;
  @Input({ required: true }) contentTemplate!: TemplateRef<HTMLTemplateElement>;
  @Input() buttonTextDismiss?: string;
  @Input() bodyText?: string;

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  public onAccept(): void {
    this.ngbActiveModal.close(true);
  }
}
